import React, { FC, useState } from "react";
import "./PasswordInput.scss";

type Props = {
  placeholder?: string;
  className?: string;
};

const PasswordInput: FC<Props> = ({ placeholder, className, ...restProps }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  return (
    <>
      <div className="PasswordInput-otr">
        <input
          className={`PasswordInput-theme ${className}`}
          type={isPasswordVisible ? "input" : "password"}
          name="text"
          placeholder={placeholder}
          {...restProps}
        />
        <div onClick={() => setIsPasswordVisible((prev) => !prev)}>
          {isPasswordVisible ? (
            <i className="bi bi-eye-slash PasswordInput-icon"></i>
          ) : (
            <i className="bi bi-eye PasswordInput-icon"></i>
          )}
        </div>
      </div>
    </>
  );
};

export default PasswordInput;
